<template>
  <div class="layout">
    <aside :class="{collapse: collapse}">
      <header>
        <img src="../assets/images/logo.png" />
      </header>
      <el-menu
        router
        :default-active="$store.state.global.path"
        :collapse="collapse"
        @select="select"
      >
        <template v-for="(value, key) in $store.state.global.menus">
          <el-menu-item v-if="+value === 1" :key="key" :index="`/${key}`">
            <i class="el-icon-setting"></i>
            <span slot="title">{{key | convertMenu}}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </aside>
    <section>
      <header>
        <i @click="$store.dispatch('toggle')"></i>
        <div>
          <el-badge :value="messageNum" v-if="messageNum">
            <i class="el-icon-bell" @click="toMessage"></i>
          </el-badge>
          <i class="el-icon-bell" v-else @click="toMessage"></i>
          <el-dropdown>
            <div class="el-dropdown-link">
              <span>{{$store.state.global.user}}</span>
              <i class="el-icon-arrow-down"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="pwdVisible = true">修改密码</el-dropdown-item>
              <el-dropdown-item @click.native="$store.dispatch('logout')">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </header>
      <breadcrumb/>
      <main>
        <keep-alive :include="['changjing']">
          <router-view class="view" v-loading="loading" />
        </keep-alive>
      </main>
    </section>
    <password v-model="pwdVisible"></password>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import password from '@/components/password'
import * as types from '@/store/mutation-types'
import breadcrumb from '@/components/common/breadcrumb'

export default {
  name: 'layout',
  components: { password, breadcrumb },
  data() {
    return {
      loading: false,
      pwdVisible: false,
      messageNum: 0
    }
  },
  computed: {
    ...mapState({
      collapse: 'collapse'
    })
  },
  created() {
    // console.log('输出', this.$store.state.global.menus)
    this.$root.$on(
      'loading',
      loading =>
        (this.loading = loading === undefined ? !this.loading : loading)
    )
    this.$store.dispatch('fetchChannels')
    this.getMessageNum()
    setTimeout(() => {
      this.getMessageNum()
    }, 300000)
  },
  beforeDestroy() {
    this.$root.$off('loading')
  },
  methods: {
    select(index) {
      if (index !== this.$store.state.global.path) {
        this.$store.commit(types.RECORD_GLOBAL_PATH, index)
      }
    },
    getMessageNum() {
      this.$api.message.check().then(res => {
        this.messageNum = res.data.number
      })
    },
    toMessage() {
      this.$router.push('message')
    }
  }
}
</script>

<style lang="scss">
.layout {
  display: flex;
  > aside {
    color: #fff;
    width: $aside-width;
    background: $aside-background;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 15;
    transition: $transition;
    left: 0px;
    box-shadow: 5px 0px 10px 0px rgba(80, 80, 80, 0.1);
    &.collapse {
      width: $aside-width--collapse;
      > header img {
        width: $aside-width--collapse - 10;
      }
      + section {
        margin-left: $aside-width--collapse;
        width: calc(100% - #{$aside-width--collapse});
        > header {
          left: if($header-fixed, $aside-width--collapse, 0);
          > i {
            transform: rotate(180deg);
          }
        }
      }
    }
    > header {
      background: #fff;
      height: $header-height;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid $color-border;
      img {
        transition: $transition;
        height: $header-height - 30;
        object-fit: contain;
      }
    }
    .el-menu {
      border-right: none;
      overflow-y: auto;
      height: 100%;
    }
  }
  > section {
    width: calc(100% - #{$aside-width});
    margin-left: $aside-width;
    min-height: 100vh;
    transition: $transition;
    > header {
      height: $header-height;
      padding: $header-padding;
      border-bottom: 1px solid $color-border;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: if($header-fixed, fixed, relative);
      top: 0;
      left: if($header-fixed, $aside-width, 0);
      right: 0;
      z-index: 10;
      transition: $transition;
      .el-icon-arrow-down {
        margin-left: 4px;
      }
      > i {
        width: 24px;
        height: 24px;
        background: url(../assets/images/icon-menu.png) center/cover;
      }

      .el-icon-bell{
        margin-right:20px;
        cursor:pointer;
      }
      .el-badge{
        margin-right:20px;
        .el-icon-bell{
          margin-right:0;
        }
      }
    }
    > main {
      min-height: calc(100vh - #{$header-height} - 48px);
      margin-top: if($header-fixed, $header-height, 0);
      background: $color-background;
      padding: $main-padding;
    }
  }
}
</style>
